@if (radioForm) {
  <div class="specialist-selection-container">
    <app-info-box
      title="{{ 'steps.specialistSelection.type_consultation' | translate }}"
      description="{{ 'steps.specialistSelection.select_specialty' | translate }}"
    ></app-info-box>
    <div class="container-radio-elements" [formGroup]="radioForm">
      <nz-radio-group [formControlName]="'specialistType'">
        <div class="radio-element-container" *ngFor="let radioElement of specialistSelection; let i = index">
          <h2>{{ radioTitles[i] | translate }}</h2>
          <nz-divider></nz-divider>
          <div class="radio-element-list">
            <div *ngFor="let radioButton of radioElement; let j = index">
              <label nz-radio [nzValue]="radioButton">{{ radioLabels[i][j] | translate }}</label>
            </div>
          </div>
        </div>
      </nz-radio-group>
    </div>
  </div>
}
